import {ChangeDetectorRef, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Store } from '@ngrx/store';
import { combineLatest, firstValueFrom, Observable, of, Subscription } from 'rxjs';
import { filter, map, shareReplay, startWith, switchMap, take, tap, withLatestFrom } from 'rxjs/operators';
import { CustomerEntity } from '../../../dave-data-module/entities/customer.entity';
import { EmailEntity } from '../../../dave-data-module/entities/email.entity';
import { EventTypeEntity } from '../../../dave-data-module/entities/event-type.entity';
import { PersonEntity } from '../../../dave-data-module/entities/person.entity';
import { Person2EntityEntity, Person2EntityEntityTypeEnum } from '../../../dave-data-module/entities/person2entity.entity';
import { UserEntity } from '../../../dave-data-module/entities/user.entity';
import { FrontendDate } from '../../../dave-data-module/helper/backend-frontend-conversion.helper';
import { State } from '../../../dave-data-module/State';
import { EventsActionTypes } from '../../../dave-data-module/State/actions/events.actions';
import { Person2EntityActionTypes } from '../../../dave-data-module/State/actions/person2entity.action';
import { getCommissionDictionary, getCommissionsActive } from '../../../dave-data-module/State/selectors/commission.selector';
import { getEmailConnections } from '../../../dave-data-module/State/selectors/email-connection.selectors';
import { getEvents } from '../../../dave-data-module/State/selectors/events.selectors';
import { getPartner } from '../../../dave-data-module/State/selectors/partners.selectors';
import { getPersonById, getPersonDictionary, getPersons} from '../../../dave-data-module/State/selectors/person.selectors';
import { getPerson2Entities } from '../../../dave-data-module/State/selectors/person2entity.selectors';
import { getUser, getUserDictionary, getUsers} from '../../../dave-data-module/State/selectors/users.selectors';
import { IDetailListTemplateData } from '../../../dave-utils-module/dave-shared-components-module/components/detail-views/detail-list-template/detail-list-template.component';
import { appMatDialogDefaultConfig, isNotNullOrUndefined } from '../../../helper/helper';
import { getErrorMessage } from '../../../helper/validation.helper';
import { getEventTypes } from '../../../dave-data-module/State/selectors/event-type.selector';
import { EmailActionTypes} from "../../../dave-data-module/State/actions/email.actions";
import { LoadingService } from '../../../services/loading.service';
import { getProcessDictionary, getProcesses, getProcessFetched } from '../../../dave-data-module/State/selectors/process.selector';
import { SelectSearchOption } from '../../../dave-utils-module/select-search/components/select-search/select-search.component';
import { ProcessEntity } from '../../../dave-data-module/entities/process.entity';
import { ProcessResolver } from '../../../dave-data-module/guards/process.resolver';
import { SelectPersonService} from "../../../services/select-person.service";
import { CustomLabelService } from "../../../services/custom-label/custom-label.service";
import { isNullOrUndef } from 'chart.js/helpers';
import { CommissionEntity } from '../../../dave-data-module/entities/commission.entity';
import { getFetched$ } from '../../../dave-data-module/helper/helper';
import { getEmployeesActiveSortedByNameStartWithMe } from 'src/app/dave-data-module/State/selectors/employees.selectors';
import { Actions, ofType } from '@ngrx/effects';
import { CustomerDataService, CustomerSearchState } from '../../../dave-data-module/services/customer-data.service';

export interface EventFromEmailComponentDialogData {
    Email?: EmailEntity;
    Emails?: EmailEntity[];
}
@Component({
    selector: 'app-event-from-email',
    templateUrl: 'event-from-email.component.html',
    styleUrls: ['event-from-email.component.scss'],
})
export class EventFromEmailComponent implements OnInit, OnDestroy {
    public static DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
        hasBackdrop: false,
        width: '600px',
    };
    public ChipListData$: Observable<IDetailListTemplateData>;
    private selectedPerson2Entity: Person2EntityEntity[] = [];
    public PersonList: Array<PersonEntity> = [];
    public Customer: CustomerEntity;
    protected customerLabel$: Observable<string> = this.cls.getSingle$('CustomerSupplier');
    public GetErrorMessage = getErrorMessage;
    public NewEventForm = new FormGroup({
        Customer: new FormControl<SelectSearchOption<CustomerEntity>>(null),
        Commission: new FormControl<SelectSearchOption<CommissionEntity>>(null),
        PersonId: new FormControl<PersonEntity>(null),
        Note: new FormControl<string>('', {
            updateOn: 'blur',
        }),
        Name: new FormControl<string>('E-Mail', {
            updateOn: 'blur',
        }),
        Users: new FormControl<UserEntity[]>(null),
        BeiteiligtePersons: new FormControl<PersonEntity[]>(null),
        Process: new FormControl<SelectSearchOption<ProcessEntity>>(null)
    });
    public EventType: EventTypeEntity = null;
    public UserId: number = null;
    public Event$ = this.Dialogdata?.Email ? this.store.select(getEvents).pipe(map(events => events.find(e => e.EmailId === this.Dialogdata.Email.Id)),
        shareReplay({bufferSize: 1, refCount: true}),
    ) : of(null);

    public IsEditing$ = this.Dialogdata?.Email ? this.Event$.pipe(map(e => !!e)) : of(false);

    private subscriptions: Subscription[] = [];
    protected processOptions$ = this.store.select(getProcessFetched).pipe(
        tap(f =>{
            if (!f) {
                this.processResolver.resolve()
            }
        }),
        filter(f => f),
        switchMap(() => this.store.select(getProcesses)),
    );
    private get emails(): EmailEntity[] {
        return this.Dialogdata.Emails ?? (this.Dialogdata.Email ? [this.Dialogdata.Email] : []);
    }

    private get firstEmail(): EmailEntity | null {
        return this.emails[0] ?? null;
    }
    protected customerSearch: CustomerSearchState = this.customerDataService.createSearchState();
    private customerLable: string = '';

    constructor(
        private store: Store<State>,
        @Inject(MAT_DIALOG_DATA)
        public Dialogdata: EventFromEmailComponentDialogData,
        public LS: LoadingService,
        private dialogRef: MatDialogRef<EventFromEmailComponent>,
        private cdr: ChangeDetectorRef,
        private sp: SelectPersonService,
        protected cls: CustomLabelService,
        protected processResolver: ProcessResolver,
        private actions$: Actions,
        private customerDataService: CustomerDataService,
    ) {
        if(this.Dialogdata?.Emails) {
            this.NewEventForm.controls.PersonId.disable({ emitEvent: false });
            this.NewEventForm.controls.Process.disable({ emitEvent: false });
            this.NewEventForm.controls.BeiteiligtePersons.disable({ emitEvent: false });
        }
    }

    ngOnInit() {
        firstValueFrom(this.store.select(getUser)).then( user => this.UserId = user.Id);
        this.subscriptions.push(
            combineLatest([
                combineLatest([
                    this.store.select(getPersons).pipe(map(p => p.filter(pe => !pe.Deleted))),
                    this.store.select(getPerson2Entities).pipe(map(pes => pes.filter(pe => pe.EntityType === Person2EntityEntityTypeEnum.Customer || pe.EntityType === Person2EntityEntityTypeEnum.Commission))),
                    this.NewEventForm.controls.Customer.valueChanges,
                    this.NewEventForm.controls.Commission.valueChanges,
                ]).pipe(
                    map(([persons, person2Entities, customerId, commissionId/*, personId*/]) =>
                        customerId?.Id || commissionId?.Id || this.NewEventForm.controls.PersonId.value || this.Dialogdata.Email.PersonId
                            ? persons.filter(p =>
                            p.Id == this.Dialogdata.Email.PersonId ||
                                  person2Entities.some(
                                      pe =>
                                          pe.PersonId === p.Id &&
                                          ((pe.EntityType === Person2EntityEntityTypeEnum.Customer && pe.EntityId === customerId?.Id) ||
                                              (pe.EntityType === Person2EntityEntityTypeEnum.Commission && pe.EntityId === commissionId?.Id)),
                                  ),
                              )
                            : []
                    ),
                ),
                this.Event$,
            ]).subscribe(([c, e]) => {
                this.PersonList = c.filter(a => !a.Deleted).map( p => p);
            }),
            this.customerLabel$.subscribe((cl) => {
                this.customerLable = cl;
            }),


            this.NewEventForm.controls.Commission.valueChanges.pipe(
                    switchMap(c => c?.CustomerId ? this.customerDataService.GetSingleCustomer$(c.CustomerId) : of(null)),
                ).subscribe(c => {
                let currentCommission = this.NewEventForm.controls.Commission.value;
                let currentCustomer = this.NewEventForm.controls.Customer.value;
                if (isNotNullOrUndefined(currentCommission) && isNullOrUndef(currentCustomer) && c?.Id) {
                    this.NewEventForm.controls.Customer.setValue(c || null);
                }
            }),

            this.NewEventForm.controls.Customer.valueChanges.pipe(
                tap(customer => {
                    if (customer && this.NewEventForm.controls.Commission.value && this.NewEventForm.controls.Commission.value.CustomerId !== customer.Id) {
                        this.NewEventForm.controls.Commission.setValue(null, {emitEvent: false})
                    }
                }),
                switchMap(customer => customer?.Id ? this.customerDataService.GetSingleCustomer$(customer.Id) : of(null)),
            ).subscribe(customer => {
                this.Customer = customer;
                this.cdr.detectChanges();
            }),
            combineLatest([this.store.select(getEventTypes), this.store.select(getEmailConnections)]).subscribe(([types, connections]) => {
                let connection = connections?.find(c => c.Id == this.firstEmail.EmailConnectionId);
                if (connection) {
                    this.EventType = types?.find(t => t.Id == connection?.EventTypeId);
                }
            }),
            this.Event$.pipe(
                filter(isNotNullOrUndefined),
                withLatestFrom(this.store.select(getCommissionDictionary),
                    this.store.select(getPersonDictionary),
                    this.store.select(getPerson2Entities),
                    this.store.select(getUserDictionary),
                    this.store.select(getProcessDictionary),
                ))
                .subscribe(([event, commissions, persons, person2Entities, users, processes]) => {

                const commission = event.CommissionId ? commissions[event.CommissionId] : null;
                combineLatest([
                    this.store.select(getPersonById({ id: event.PersonId})),
                    event.CustomerId ? this.customerDataService.GetSingleCustomer$(event.CustomerId) : of(null),
                ]).pipe(take(1)).subscribe( ([p, customer]) => {
                    this.NewEventForm.setValue({
                        Customer: customer || null,
                        Commission: commission || null,
                        PersonId: p ? p : null,
                        Note: event.Description ? event.Description : '',
                        Name: 'E-Mail',
                        Users: event.UserIds?.map(uId => users[uId]).filter(isNotNullOrUndefined),
                        BeiteiligtePersons: person2Entities.filter(p2e => p2e.EntityType === Person2EntityEntityTypeEnum.Event && p2e.EntityId === event.Id).map(p2e => persons[p2e.PersonId]).filter(isNotNullOrUndefined),
                        Process: event.ProcessId ? processes[event.ProcessId] : null,
                    })
                })
            }),
            combineLatest([
                this.store.select(getPersons).pipe(filter(isNotNullOrUndefined)),
                this.Event$,
                this.store.select(getPerson2Entities).pipe(filter(isNotNullOrUndefined)),
            ])
                .pipe()
                .subscribe(([persons, event, person2Entities]) => {
                    this.selectedPerson2Entity = event ? person2Entities?.filter(p2e => p2e.EntityType === Person2EntityEntityTypeEnum.Event && p2e.EntityId === event.Id) : [];
                    if(this.PersonList?.length == 0 && this.Dialogdata.Email.PersonId != null){
                        this.PersonList = persons.filter(p => p.Id == this.Dialogdata.Email.PersonId).map( pl => pl);
                    }
                    if (!event) {
                        this.store.select(getPersonById({ id: this.Dialogdata.Email.PersonId })).pipe(take(1)).subscribe( p => {
                            this.NewEventForm.controls.PersonId.setValue(
                                p ? p : null
                            )
                        });
                        this.NewEventForm.controls.Users.setValue([])
                        this.NewEventForm.controls.Customer.setValue(null);
                        if (isNotNullOrUndefined(this.Dialogdata.Email.CustomerId)) {
                            this.customerDataService.GetSingleCustomer$(this.Dialogdata.Email.CustomerId).pipe(take(1)).subscribe(c => {
                                this.NewEventForm.controls.Customer.setValue(c || null);
                                this.cdr.detectChanges();
                            });
                        } else {
                            if (isNotNullOrUndefined(this.NewEventForm.controls.PersonId.value)) {
                                const person2cu = person2Entities.filter(p2e=> p2e.EntityType == Person2EntityEntityTypeEnum.Customer && p2e.PersonId == this.NewEventForm.value.PersonId.Id);
                                const customerIds = [...new Set(person2cu.map(p2cu => p2cu.EntityId))];
                                if (customerIds.length) {
                                    this.customerDataService.GetCustomers$(customerIds).pipe(take(1)).subscribe(customers => {
                                        const cu = customers.filter(c => !c.Deleted);
                                        if (cu.length == 1) {
                                            this.NewEventForm.controls.Customer.setValue(cu[0]);
                                        }
                                        this.cdr.detectChanges();
                                    });
                                }
                            }
                        }
                    }
                    this.cdr.detectChanges();
                }),
        );
        this.ChipListData$ = combineLatest([
            this.store.select(getUsers).pipe(filter(isNotNullOrUndefined)),
            this.store.select(getEmployeesActiveSortedByNameStartWithMe).pipe(
                map((employees) => employees.filter((e) => e.UserId))
            ),
            this.store.select(getPersons).pipe(filter(isNotNullOrUndefined)),
            this.store.select(getPartner).pipe(filter(isNotNullOrUndefined)),
            this.Event$,
            this.cls.getSingle$('Commission')
        ]).pipe(
            map(([users, employeeUsers, persons, partner, event, commissionLabel]) => {
                const activeUsers = users.filter((u) => employeeUsers.some((e) => e.UserId == u.Id))
                return{
                    Properties: [
                        {
                            key: commissionLabel,
                            formControl: this.NewEventForm.controls.Commission,

                            options: {
                                specialInput: {
                                    singleSelectSearch: {
                                        options$: combineLatest([
                                                this.store.select(getCommissionsActive),
                                                this.NewEventForm.controls.Customer.valueChanges.pipe(startWith(''), map(() => this.NewEventForm.controls.Customer.value)),
                                            ]).pipe(
                                                map(([commissions, customer]) => (customer?.Id ? commissions.filter(c => c.CustomerId === customer.Id) : commissions)),
                                            ),
                                        compareOptions: (a, b) => (a?.Id ?? null) === (b?.Id ?? null),
                                    },
                                },
                            },
                        },
                        {
                            key: 'Name',
                            formControl: this.NewEventForm.controls.Name,
                        },{
                            key: 'Notiz',
                            formControl: this.NewEventForm.controls.Note,
                            options: {
                                specialInput: {
                                    textArea: { Fill: true },
                                },
                            },
                        },
                        {
                            key: 'Zugewiesene Mitarbeiter',
                            formControl: this.NewEventForm.controls.Users,
                            options: {
                                specialInput: {
                                    chipAutocomplete: {
                                        MapFn: (option: UserEntity) => [option.DisplayName, option.Email].filter(isNotNullOrUndefined).join(', '),
                                        Options: activeUsers.filter(e => e.PartnerId === partner.Id) || [],
                                        initialPatchDefaultValue: true,
                                    },
                                },
                            },
                        },
                        {
                            key: 'Beteiligte Personen',
                            formControl: this.NewEventForm.controls.BeiteiligtePersons,
                            options: {
                                specialInput: {
                                    chipAutocomplete: {
                                        MapFn: (option: PersonEntity) => [option.DisplayName, option.Email].filter(isNotNullOrUndefined).join(', '),
                                        Options: persons.filter(u => u.PartnerId === partner.Id) || [],
                                        initialPatchDefaultValue: true,
                                    },
                                },
                            },
                        },
                    ],
                };
            }),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    public async Submit() {
        if (this.NewEventForm.invalid) {
            return;
        }
        const { PersonId, Note, Customer, Commission, BeiteiligtePersons, Users } = this.NewEventForm.value;
        this.LS.startLoading('submitEventForEmail');
        const events = await firstValueFrom(this.store.select(getEvents));
        for (const email of this.emails) {

        const event = events.find(e => e.EmailId === email.Id);

            if (event) {
                this.store.dispatch(
                    EventsActionTypes.ModifyEvent({
                        Payload: {
                            id: event.Id,
                            personId: PersonId?.Id || null,
                            customerId: Customer?.Id || null,
                            commissionId: Commission?.Id || null,
                            description: Note || '',
                            userIds: isNotNullOrUndefined(Users) ? Users.map(u => u.Id) : null,
                        },
                    }),
                );

                    this.store.dispatch(EmailActionTypes.ModifyEmail({
                        Payload: {
                            id: email.Id,
                            customerId: Customer?.Id || null,
                            commissionId: Commission?.Id || null,
                        }
                    }));
                await firstValueFrom(
                    this.actions$.pipe(
                        ofType(EmailActionTypes.UpdateOneEmail),
                        filter(action => action.Payload?.Id === email.Id),
                        take(1),
                    ),
                );


                if (isNotNullOrUndefined(BeiteiligtePersons)) {
                    //adding and deleting person2Entity
                    let addIds: number[] = [];
                    let delIds: number[] = [];

                    BeiteiligtePersons.forEach(p => {
                        if (this.selectedPerson2Entity.filter(pe => pe.PersonId === p.Id).length === 0) {
                            addIds.push(p.Id);
                        }
                    });

                    this.selectedPerson2Entity.forEach(pe => {
                        if (BeiteiligtePersons.filter(p => p.Id === pe.PersonId).length === 0) {
                            delIds.push(pe.Id);
                        }
                    });
                    addIds.forEach(pId => {
                        this.store.dispatch(
                            Person2EntityActionTypes.AddPerson2Entity({
                                Payload: {
                                    personId: pId,
                                    entityId: event.Id,
                                    entityType: Person2EntityEntityTypeEnum.Event,
                                },
                            }),
                        );
                    });

                    delIds.forEach(id => {
                        this.store.dispatch(
                            Person2EntityActionTypes.DeletePerson2Entity({
                                Payload: {
                                    id: id,
                                },
                            }),
                        );
                    });
                }
            } else {

                this.store.dispatch(
                    EventsActionTypes.AddEvent({
                        Payload: {
                            personId: PersonId?.Id,
                            customerId: Customer?.Id  || null,
                            hint: null,
                            street: null,
                            city: null,
                            postalCode: null,
                            commissionId: Commission?.Id  || null,
                            eventTypeId: this.EventType.Id,
                            eventDate: FrontendDate(email?.SendDate),
                            eventEndDate: FrontendDate(email?.SendDate),
                            description: Note || '',
                            name: this.NewEventForm.value.Name,
                            private: false,
                            emailId: email.Id,
                            userIds: isNotNullOrUndefined(Users) ? [...Users.filter(user => user.Id !== this.UserId).map(u => u.Id), this.UserId] : this.UserId ? [this.UserId] : null,
                            personIds: isNotNullOrUndefined(BeiteiligtePersons) ? BeiteiligtePersons.map(p => p.Id) : null,
                            documentIds: email.DocumentIds,
                        },
                    })
                );
                await firstValueFrom(
                    this.actions$.pipe(
                        ofType(EventsActionTypes.UpdateEvent),
                        filter(action => action.Payload?.EmailId === email.Id),
                        take(1),
                    ),
                );

                this.store.dispatch(EmailActionTypes.ModifyEmail({
                    Payload: {
                        id: email.Id,
                        customerId: Customer?.Id  || null,
                        commissionId:  Commission?.Id  || null,
                    }
                }));

            }

        }
            this.LS.endLoading('submitEventForEmail');
            this.dialogRef.close();

    }

    public NewContactPerson() {
        const customerId = this.NewEventForm.value.Customer?.Id;
        firstValueFrom(isNotNullOrUndefined(customerId) ? this.customerDataService.GetSingleCustomer$(customerId) : of(null)).then( value => this.sp.OpenPersonDialog(null, value))

    }
    protected customerCompareOptions = (a, b) => a?.Id === b?.Id;
    protected customerpageChange = (event) => this.customerSearch.customerPageChange(event);
    protected customerserverSearch = (search) => this.customerSearch.SearchCustomers(search, 'unbenannter' + this.customerLable);
    public compareById = (a: {Id} | null, b: {Id} | null) => (a?.Id ?? null) === (b?.Id ?? null);
}
